export class RequestVisitorAttachFile {
    classify: string = '';
    fileName: string = '';
    fileId: string = '';
}
